<h3>Showcase Video</h3>
<div class="media-box" *ngIf="!!this.safeVideoUrl">
  <iframe class="media" [src]="safeVideoUrl" title="Video"></iframe>
</div>
